/* This example requires Tailwind CSS v2.0+ */
import {Dialog, Transition} from "@headlessui/react";
import {Fragment, useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {getList} from "../../services/service";
import saveItem from "../../services/service";
import ComboboxComponent from "../Combobox";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";

export default function ModalAddAdditionalSpecification({
                                                            open,
                                                            handleClose,
                                                            additionalId,
                                                            id,
                                                            fetchData_, isEdit
                                                        }) {
    const cancelButtonRef = useRef(null);
    const {token} = useSelector((state) => state.user);
    const [productList, setProductList] = useState([]);
    const [textureData, setTextureData] = useState([]);
    const [productId, setProductId] = useState(null);
    const [textureId, setTextureId] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [selectedTexture,setSelectedTexture] = useState("");

    const navigate = useNavigate();
    const {t} = useTranslation()

    const fetchDataProduct = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/article/product`,
            token
        );
        if (response.success) {
            setProductList(response.data);
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };
    const fetchDataTexture = async (productId, textureId) => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/texture/list/by/productId/${productId}`,
            token
        );
        if (response.success) {
            const processingData = response?.data.map((item) => {
                return {
                    id: item.id,
                    displayValue: item.name,
                    name: (
                        <div className="flex justify-between ">
                            <p>{item.name}</p>
                            <div
                                style={{
                                    backgroundColor: `${item.color}`,
                                    width: "50%",
                                    borderRadius: "4px",
                                }}
                            ></div>
                        </div>
                    ),
                };
            });
            setTextureData(processingData);

            if (textureId){
                const find_texture = processingData.find((item)=> item?.id === textureId);
                setSelectedTexture(find_texture);
                console.log(find_texture);
            }
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };
    useEffect(() => {
        if (additionalId) {
            fetchDataProduct();
        }
        if (!open) {
            setProductId(null);
            setTextureId(null);
            setTextureData([]);
            setSelectedProduct(null);
            setSelectedTexture(null);
        }
    }, [additionalId, open]);

    useEffect(() => {
        console.log(isEdit, 'isEdit')
        if (isEdit) {

            console.log(isEdit, 'isEdit')
            const getData = async () => {
                const response = await getList(`${process.env.REACT_APP_HOST_BASE_URL}/v1/additional/specification/${id}`, token);
                console.log(response, 'response');
                const find_product = productList.find((item) => item?.id === response?.data?.productId);
                setSelectedProduct(find_product);
                setTextureId(response?.data?.textureId)
                setProductId(response?.data?.productId)
                if (find_product) {
                    setProductId(find_product.id);
                }
                fetchDataTexture(response?.data?.productId, response?.data?.textureId);
            }
            getData();
        } else {
            setSelectedProduct(null)
        }
    }, [id])

    useEffect(() => {
        if (selectedProduct && selectedProduct.id)
            fetchDataTexture(selectedProduct.id);
        else if (productId) fetchDataTexture(productId);
    }, [selectedProduct, productId])

    const handleChangeProduct = (value) => {
        setProductId(value.id);
        fetchDataTexture(value.id);
    };
    const handleChangeTexture = (value) => {
        setTextureId(value.id);
    };

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        const response = await saveItem(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/additional/specification`,
            token,
            {
                id: id ? id : null,
                productId: productId,
                additionalId: additionalId,
                textureId: textureId,
            }
        );
        if (response.success) {
            fetchData_();
            handleClose();
            toast.success(t('action.add_success'), {
                position: "bottom-right",
                autoClose: 3000,
                closeOnClick: true,
                className: "add-success"
            });
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-10"
                initialFocus={cancelButtonRef}
                onClose={handleClose}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"/>
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className="relative px-4 pt-5 pb-4 text-left transition-all transform bg-white rounded-lg shadow-xl  sm:my-8 sm:w-full sm:max-w-lg sm:p-6 ">
                                <form onSubmit={handleSubmit}>
                                    <div className="">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-medium leading-6 text-gray-900"
                                        >
                                            {t('add_additional_specification')}
                                        </Dialog.Title>
                                        <div className="mt-8">
                                            <ComboboxComponent
                                                label={t('products')}
                                                data={productList}
                                                item={selectedProduct ? selectedProduct : null}
                                                onChange={handleChangeProduct}
                                            />
                                        </div>
                                        <div className="mt-3">
                                            <ComboboxComponent
                                                label={t('textures')}
                                                data={textureData}
                                                item={selectedTexture}
                                                onChange={handleChangeTexture}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="mt-8 sm:mt-10 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                        <button
                                            type="submit"
                                            className={`${
                                                productId
                                                    ? "inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-indigo-500 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
                                                    : "inline-flex  justify-center w-full px-4 py-2 text-base font-medium text-white bg-indigo-200 border border-transparent rounded-md shadow-sm hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:ring-offset-2 sm:col-start-2 sm:text-sm cursor-no-drop"
                                            } `}
                                            disabled={productId ? false : true}
                                        >
                                            {t('save')}
                                        </button>
                                        <button
                                            type="button"
                                            className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm"
                                            onClick={handleClose}
                                            ref={cancelButtonRef}
                                        >
                                            {t('cancel')}
                                        </button>
                                    </div>
                                </form>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
